module.exports = __webpack_public_path__ + "img/backpack-table-icon.cebe8866.svg";